<template>
     <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="$t('newsPage.title')"
                :description="$t('newsPage.description')"
            />
        </template>
        <template v-slot:content>
            <div class="box container-fluid w-100">
                <div class="row" v-if="$te('newsPage.slots')">
                    <div
                        :key="item.id"
                        v-for="(item, index) in $t('newsPage.slots')"
                        :style="{
                            position: 'relative',
                            overflow: 'hidden'
                        }"
                        class="col-md-6 inner"
                        :class="{
                            'inner--odd': index%2 === 0
                        }">

                        <img
                            class="mask-image"
                            v-if="item.responsiveImage"
                            :src="item.responsiveImage.src"
                            :srcset="item.responsiveImage.srcset"
                        />

                        <div class="mask"></div>

                        <div class="inner__text-content box box--space-horizontal">
                            <div class="box box--space-inside">
                                <span class="headline headline--third mt-2 pb-3">
                                    {{item.name}}
                                </span>
                                <router-link :to="localeRoute(item.routeName)"
                                    class="button button--xl normal--button button--small-text button--shadow">
                                    {{item.buttonLabel}}
                                </router-link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </LayoutPage>
</template>

<script>

import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
        BannerSmallerWithSearchAndButton,
        LayoutPage
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    },
    methods: {

    }
}
</script>

<style scoped>
.inner {
    height: 300px;
    position: relative;
    background-position: right;
}

.inner__text-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.mask {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-repeat: no-repeat;
    background: linear-gradient(to right, rgba(255,255,255, 0.95) , rgba(255,255,255, 0.01));
}


.mask-image {
    position: absolute;
    width: auto;
    left: 0;
    min-height: 100%;
}

.inner--odd .mask-image {
    right: 0;
    left: auto;
}

@media (max-width: 767px) {
    .mask {
        background: linear-gradient(0deg, rgba(255,255,255, 0.9) 25%, transparent 80%);
        background-repeat: no-repeat;
        background-position: top;
    }

    .inner {
        height: 400px;
    }
}

@media (min-width: 1920px) {
    .inner--odd .inner__text-content {
        right: 0;
        width: 800px;
        bottom: 0;
        left: auto;
    }
}
</style>